import { render } from "./AsMenu.vue?vue&type=template&id=6c5ebfaa&ts=true"
import script from "./AsMenu.vue?vue&type=script&lang=ts"
export * from "./AsMenu.vue?vue&type=script&lang=ts"

import "./AsMenu.vue?vue&type=style&index=0&id=6c5ebfaa&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__